/*
  BFS Fabric Guard v1.0 (Oct 2026)
  A made-to-order bed can't be made without a fabric, so Add to basket / Buy now is blocked
  until one is chosen. Only applies to product pages that actually have a fabric choice
  (a properties[Fabric] input plus fabric swatches or a fabric group), so mattresses and
  kids beds with a fixed fabric are unaffected.

  The configurator pages default a fabric on load; this is the safety net for any template
  that doesn't, and for a shopper who somehow clears it.
*/
(function () {
  'use strict';

  var ATC_SEL = '[data-bfs-add-to-cart], [data-bfs-buy-now], .bfs-atc, .bfs-buy-now';
  var MESSAGE = 'Please choose a fabric before adding to basket.';

  function fabricInput(root) { return root.querySelector('input[name="properties[Fabric]"]'); }

  function needsFabric(root) {
    var input = fabricInput(root);
    if (!input) return false;
    if (!root.querySelector('.bfs-colour-swatch, [data-bfs-group="fabric"]')) return false;
    return !String(input.value || '').trim();
  }

  function fail(root) {
    var box = root.querySelector('[data-bfs-atc-error]');
    if (box) {
      box.classList.remove('hidden');
      var msg = box.querySelector('.product-form__error-message');
      if (msg) msg.textContent = MESSAGE;
    }
    var g = root.querySelector('.bfs-group[data-bfs-group="fabric"]');
    if (g) {
      g.classList.add('is-open');
      var sb = g.querySelector('.bfs-group-summary');
      if (sb) sb.setAttribute('aria-expanded', 'true');
      try { g.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest(ATC_SEL);
    if (!btn) return;
    var root = btn.closest('.bfs-product');
    if (!root || !needsFabric(root)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    fail(root);
  }, true);
})();
